export const routesStok = [
  {
    path: "/stokdepo",
    name: "stokdepo",
    component: () => import("@/views/stok/depo/index.vue"),
    meta: {
      public: false,
      title: "Depo",
      yetki: { k: [1030102] },
    },
  },
  {
    path: "/stokgroup",
    name: "stokgroup",
    component: () => import("@/views/stok/stokgroup/index.vue"),
    meta: {
      public: false,
      title: "Stok Group",
      yetki: { k: [1030702] },
    },
  },
  {
    path: "/stokkarti",
    name: "stokkarti",
    component: () => import("@/views/stok/stokKarti/index.vue"),
    meta: {
      public: false,
      title: "Stok Kartı",
      yetki: { k: [1030202] },
    },
  },
  {
    path: "/stokgiris",
    name: "stokgiris",
    component: () => import("@/views/stok/stok_giris/index.vue"),
    meta: {
      public: false,
      title: "Stok Giriş",
      yetki: { k: [1030302] },
    },
  },
  {
    path: "/stokgiris/:uuid",
    name: "stokgirisduzeltme",
    component: () => import("@/views/stok/stok_giris/duzeltme.vue"),
    meta: {
      public: false,
      title: "Stok Giriş Düzeltme",
      yetki: { k: [1030302] },
    },
  },
  {
    path: "/stokcikis",
    name: "stokcikis",
    component: () => import("@/views/stok/stok_cikis/index.vue"),
    meta: {
      public: false,
      title: "Stok Çıkış",
      yetki: { k: [1030402] },
    },
  },
  {
    path: "/stokcikis/:uuid",
    name: "stokcikisduzeltme",
    component: () => import("@/views/stok/stok_cikis/duzeltme.vue"),
    meta: {
      public: false,
      title: "Stok Çıkış Düzeltme",
      yetki: { k: [1030402] },
    },
  },
  {
    path: "/satis",
    name: "satis",
    component: () => import("@/views/stok/satis/index.vue"),
    meta: {
      public: false,
      title: "Satış",
      yetki: { k: [1030802] },
    },
  },

  {
    path: "/satis/:uuid",
    name: "satisduzeltme",
    component: () => import("@/views/stok/satis/duzeltme.vue"),
    meta: {
      public: false,
      title: "Satış Düzeltme",
      yetki: { k: [1030802] },
    },
  },
  {
    path: "/satishizli",
    name: "satishizli",
    component: () => import("@/views/stok/satishizli/index.vue"),
    meta: {
      public: false,
      title: "Satış",
      yetki: { k: [1030808] },
    },
  },

  {
    path: "/satishizli/:uuid",
    name: "satishizliduzeltme",
    component: () => import("@/views/stok/satishizli/duzeltme.vue"),
    meta: {
      public: false,
      title: "Satış Düzeltme",
      yetki: { k: [1030808] },
    },
  },
  {
    path: "/proforma",
    name: "proforma",
    component: () => import("@/views/stok/proforma/index.vue"),
    meta: {
      public: false,
      title: "Satış",
      yetki: { k: [1031002] },
    },
  },

  {
    path: "/proforma/:uuid",
    name: "proformaduzeltme",
    component: () => import("@/views/stok/proforma/duzeltme.vue"),
    meta: {
      public: false,
      title: "Proforma Düzeltme",
      yetki: { k: [1031002] },
    },
  },
  {
    path: "/depolararasi",
    name: "depolararasi",
    component: () => import("@/views/stok/depolararasi/index.vue"),
    meta: {
      public: false,
      title: "Depolar Arası Transfer",
      yetki: { k: [1030502] },
    },
  },
  {
    path: "/depolararasi/:uuid",
    name: "depolararasiduzeltme",
    component: () => import("@/views/stok/depolararasi/duzeltme.vue"),
    meta: {
      public: false,
      title: "Depolar Arası Transfer Düzeltme",
      yetki: { k: [1030502] },
    },
  },
  {
    path: "/deposayim",
    name: "deposayim",
    component: () => import("@/views/stok/deposayim/index.vue"),
    meta: {
      public: false,
      title: "Depo Sayım",
      yetki: { k: [1030602] },
    },
  },
  {
    path: "/deposayim/:uuid",
    name: "deposayimduzeltme",
    component: () => import("@/views/stok/deposayim/duzeltme.vue"),
    meta: {
      public: false,
      title: "Depo Sayım Düzeltme",
      yetki: { k: [1030602] },
    },
  },
  {
    path: "/indirim",
    name: "indirim",
    component: () => import("@/views/stok/indirim/index.vue"),
    meta: {
      public: false,
      title: "İndirim",
      yetki: { k: [1030902] },
    },
  },
  {
    path: "/kasa",
    name: "kasa",
    component: () => import("@/views/kasa/kasa/index.vue"),
    meta: {
      public: false,
      title: "Kasa",
      yetki: { k: [1040002] },
    },
  },
  {
    path: "/kasagiris",
    name: "kasagiris",
    component: () => import("@/views/kasa/kasagiris/index.vue"),
    meta: {
      public: false,
      title: "Kasa Giriş",
      yetki: { k: [1040102] },
    },
  },
  {
    path: "/kasacikis",
    name: "kasacikis",
    component: () => import("@/views/kasa/kasacikis/index.vue"),
    meta: {
      public: false,
      title: "Kasa Çıkış",
      yetki: { k: [1040202] },
    },
  },
  {
    path: "/caribakiye",
    name: "caribakiye",
    component: () => import("@/views/kasa/caribakiye/index.vue"),
    meta: {
      public: false,
      title: "Cari Bakiye",
      yetki: { k: [1040302] },
    },
  },
  {
    path: "/kasadurum",
    name: "kasadurum",
    component: () => import("@/views/kasa/kasadurum/index.vue"),
    meta: {
      public: false,
      title: "Kasa Durum",
      yetki: { k: [1040402] },
    },
  },
  {
    path: "/odemehizli",
    name: "odemehizli",
    component: () => import("@/views/kasa/odemehizli/index.vue"),
    meta: {
      public: false,
      title: "Ödeme",
      yetki: { k: [1040508] },
    },
  },
];
